import {FxRate} from '../../model/admin/fxrate';
import {FxRateHistory} from '../../model/admin/fxratehistory';
import {BaseResponse} from '../internal/baseresponse';

export class ADMFxRateHistoryList {
  total: number;
  list: Array<FxRateHistory>;
}


export class ADMFxRateHistoryListResult extends BaseResponse {
  data?: ADMFxRateHistoryList;
};

export class ADMFxRateResult extends BaseResponse {
  data?: Array<FxRate>;
}



// WEBPACK FOOTER //
// ./src/app/response/admin/admfxrateresult.ts